<div class="flex column courses m-32 gap-32 heightError" [ngClass]="{'size': loading, 'heightError': !favorites?.length}">
	<div class="flex row space-between center">
		<div>
			<h4>{{'general.favorites' | translateWithKeys}}</h4>

		</div>
	</div>
		<mat-tab-group (selectedTabChange)="onTabChanged($event)" (animationDone)="switchingTabs()" [(selectedIndex)]="selectedTab">
			<mat-tab #coursesTab label="courses">
				@if (coursesTab.isActive) {
					<ng-template mat-tab-label>
						{{ 'general.courses' | translateWithKeys }}
					</ng-template>
					@if(pagingData?.length){
						<div class="w-100">
							<ng-container *ngTemplateOutlet="searchBar"></ng-container>
						</div>
					}
					<br>
					@if (favorites.length == 0) {
						@if (loading) {
							<div ngClass="grid">
								@for (favorite of [1, 2, 3, 4]; track $index) {
									<ngx-skeleton-loader [theme]="{ 'height': '370px' }"></ngx-skeleton-loader>
								}
							</div>
						} @else {
							@if (isThereData) {
								<div class="flex column center empty-state-container errorImage">
									<app-empty-state image="assets/images/not-results-found.png"
									title="general.not_results_found"
									text="general.not_results_found_description"></app-empty-state>
								</div>
							} @else {
								<div class="flex column center empty-state-container errorImage">
									<app-empty-state image="assets/images/favorites.png"
									title="general.empty_state_course_favorite_title"
									text="general.empty_state_course_favorite_description"></app-empty-state>
								</div>
							}
						}
					}@else {
						<div [ngClass]="{'tab-container': favorites?.length }">
						<ng-container *ngTemplateOutlet="cardsContent"></ng-container>
						</div>

					}
				}
			</mat-tab>
			<mat-tab #chapterTab [label]="'general.chapters' | translateWithKeys">
				@if (chapterTab.isActive) {
					<ng-template mat-tab-label>
						{{ 'general.chapters' | translateWithKeys }}
					</ng-template>
					@if(pagingData?.length){
						<ng-container *ngTemplateOutlet="searchBar"></ng-container>
					 }
						<br>
					@if (favorites.length == 0) {
						@if (loading) {
							<div ngClass="grid">
								@for (favorite of [1, 2, 3, 4]; track $index) {
									<ngx-skeleton-loader [theme]="{ 'height': '370px' }"></ngx-skeleton-loader>
								}
							</div>
						} @else {
							@if (isThereData) {
								<div class="flex column center empty-state-container errorImage">
									<app-empty-state image="assets/images/not-results-found.png"
									title="general.not_results_found"
									text="general.not_results_found_description"></app-empty-state>
								</div>
							} @else {
								<div class="flex column center empty-state-container errorImage">
									<app-empty-state image="assets/images/favorites.png"
									title="general.empty_state_chapter_favorite_title"
									text="general.empty_state_chapter_favorite_description"></app-empty-state>
								</div>
							}
						}
					}@else {
						<div [ngClass]="{'tab-container': favorites?.length}">
						<ng-container *ngTemplateOutlet="cardsContent"></ng-container>
						</div>

					}
				}
			</mat-tab>
		</mat-tab-group>
		<app-paging [ngClass]="{'hide': favorites.length < 8}" [options]="queryOptions" (itemsChange)="getPagingData($event)" (onPagingExecuted)="setLoading(false)"></app-paging>


	  <ng-template #searchBar>
	  <div class="flex row space-between center height">
		<div class="flex row center search-btn">
			<div class="pr-16 pt-18 search-filter">
				<app-search-bar (searchString)="handleActionSearch($event)"></app-search-bar>
			</div>
		</div>
	</div>
	</ng-template>

	<ng-template #cardsContent>
		@if(loading) {
			<div ngClass="grid">
				@for (favorite of [1, 2, 3, 4]; track $index) {
					<ngx-skeleton-loader [theme]="{ 'height': '370px' }"></ngx-skeleton-loader>
				}
			</div>
			}@else {
				<div ngClass="grid">
					@for (favorite of favorites; track $index) {
					<app-course-card [cardType]="cardTypes.FAVORITE" [favorite]="favorite" (updateView)="updateView($event)"></app-course-card>
					}
				</div>
			}
	</ng-template>
</div>
